// Sort key = last word of the name (case-insensitive), then the full name. Display is unchanged.
export const lastNameKey = n => { const p = (n || "").trim().toLowerCase().split(/\s+/); return `${p[p.length - 1] || ""} ${p.join(" ")}`; };
export const byLastName = (a, b) => lastNameKey(a).localeCompare(lastNameKey(b));
export const sortWorkers = list => [...list].sort((a, b) => byLastName(a.name, b.name));
